var _path, _path2, _path3, _path4, _path5, _defs;
const _excluded = ["svgRef"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgMathicon = _ref => {
  let {
      svgRef
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 22.75C6.07 22.75 1.25 17.93 1.25 12C1.25 6.07 6.07 1.25 12 1.25C12.41 1.25 12.75 1.59 12.75 2C12.75 2.41 12.41 2.75 12 2.75C6.9 2.75 2.75 6.9 2.75 12C2.75 17.1 6.9 21.25 12 21.25C17.1 21.25 21.25 17.1 21.25 12C21.25 11.59 21.59 11.25 22 11.25C22.41 11.25 22.75 11.59 22.75 12C22.75 17.93 17.93 22.75 12 22.75Z",
    fill: "url(#paint0_linear_2566_1654)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 22.75C6.07 22.75 1.25 17.93 1.25 12C1.25 6.07 6.07 1.25 12 1.25C12.41 1.25 12.75 1.59 12.75 2C12.75 2.41 12.41 2.75 12 2.75C6.9 2.75 2.75 6.9 2.75 12C2.75 17.1 6.9 21.25 12 21.25C17.1 21.25 21.25 17.1 21.25 12C21.25 11.59 21.59 11.25 22 11.25C22.41 11.25 22.75 11.59 22.75 12C22.75 17.93 17.93 22.75 12 22.75Z",
    fill: "url(#paint1_linear_2566_1654)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9999 11.75C12.8099 11.75 12.6199 11.68 12.4699 11.53C12.1799 11.24 12.1799 10.76 12.4699 10.47L20.6699 2.27C20.9599 1.98 21.4399 1.98 21.7299 2.27C22.0199 2.56 22.0199 3.04 21.7299 3.33L13.5299 11.53C13.3799 11.68 13.1899 11.75 12.9999 11.75Z",
    fill: "url(#paint2_linear_2566_1654)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9999 11.75C12.8099 11.75 12.6199 11.68 12.4699 11.53C12.1799 11.24 12.1799 10.76 12.4699 10.47L20.6699 2.27C20.9599 1.98 21.4399 1.98 21.7299 2.27C22.0199 2.56 22.0199 3.04 21.7299 3.33L13.5299 11.53C13.3799 11.68 13.1899 11.75 12.9999 11.75Z",
    fill: "url(#paint3_linear_2566_1654)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9999 7.58C21.5899 7.58 21.2499 7.24 21.2499 6.83V2.75H17.1699C16.7599 2.75 16.4199 2.41 16.4199 2C16.4199 1.59 16.7599 1.25 17.1699 1.25H21.9999C22.4099 1.25 22.7499 1.59 22.7499 2V6.83C22.7499 7.24 22.4099 7.58 21.9999 7.58Z",
    fill: "#455CC7"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2566_1654",
    x1: 1.39612,
    y1: 1.25,
    x2: 1.39612,
    y2: 22.4578,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3758CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3758CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2566_1654",
    x1: 12,
    y1: 1.25,
    x2: 12,
    y2: 22.75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3758CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2566_1654",
    x1: 12.3183,
    y1: 2.0525,
    x2: 12.3183,
    y2: 11.6182,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3758CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3758CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2566_1654",
    x1: 17.0999,
    y1: 2.0525,
    x2: 17.0999,
    y2: 11.75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3758CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgMathicon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/mathicon.ab8813b4.svg";
export { ForwardRef as ReactComponent };